import React from 'react';
// @ts-ignore
import styles from '../PatientProfileV2.module.scss';
import Text from '../../Base/Text/Text';
import { joinClasses } from '../../../Utils/className.util';

interface Props {
	label: string;
	value: string;
	bold?: boolean;
}

const PatientProfilePart: React.FC<Props> = ({label, value, bold = false}) => {
	return (
		<div className={styles.item}>
			<Text tx={label} className={styles.name} firstUpper colon/>
			<div className={joinClasses([styles.text, bold ? styles.bold : ''])}>{value}</div>
		</div>
	)
}

export default PatientProfilePart;